/* eslint-disable no-case-declarations */
import {
  ADD_ADDRESS, DELETE_ADDRESS, GET_ADDRESS, UPDATE_ADDRESS,
} from '../actionTypes';

const initialState = {
  data: [],
  message: '',
  error: false,
  isLoading: false,
  newAddress: false,
  deletedAddress: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_ADDRESS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_ADDRESS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_ADDRESS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        data: payload.data.data,
      };

    case `${ADD_ADDRESS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newAddress: false,
      };
    case `${ADD_ADDRESS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        newAddress: false,
      };
    case `${ADD_ADDRESS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newAddress: true,
        data: [...state.data, payload.data.data],
      };

    case `${UPDATE_ADDRESS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newAddress: false,
      };
    case `${UPDATE_ADDRESS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        newAddress: false,
      };
    case `${UPDATE_ADDRESS}_FULFILLED`:
      const newAddressesAfterFilter = state.data.map((address) => {
        if (address.id === payload.data.data.id) {
          return payload.data.data;
        } return address;
      });
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newAddress: true,
        data: newAddressesAfterFilter,
      };

    case `${DELETE_ADDRESS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        deletedAddress: false,
      };
    case `${DELETE_ADDRESS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        deletedAddress: false,
      };
    case `${DELETE_ADDRESS}_FULFILLED`:
      const filteredData = state.data.filter((address) => address.id !== payload);
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        deletedAddress: true,
        data: filteredData,
      };

    default:
      return state;
  }
}
